import React from 'react';
import { Link } from 'react-router-dom';

const COMPLIANCE_BADGES = [
  { 
    label: 'SOC 2 In Progress', 
    anchor: 'soc2', 
    variant: 'warning',
    title: 'SOC 2 Type II certification in progress',
    ariaLabel: 'SOC 2 Type II certification in progress'
  },
  { label: 'GDPR Ready', anchor: 'gdpr', variant: 'success' },
  { label: 'ISO 27001 Aligned', anchor: 'iso27001', variant: 'success' },
  { label: 'AWS Well-Architected', anchor: 'aws', variant: 'success' },
];

const ComplianceFooter: React.FC = () => (
  <footer
    role="contentinfo"
    className="text-xs text-slate-500 py-6 border-t border-slate-700"
  >
    {/* Enterprise CTA */}
    <div className="flex flex-wrap items-center justify-center gap-3 mb-4 text-sm">
      <span className="text-slate-400">Interested in RetainIQ for your organization?</span>
      <Link
        to="/apply"
        className="text-blue-400 hover:text-blue-300 transition-colors font-medium"
      >
        Apply for private beta →
      </Link>
      <span className="text-slate-600">·</span>
      <a
        href="mailto:hello@retainiq.cloud"
        className="text-slate-400 hover:text-slate-300 transition-colors"
      >
        hello@retainiq.cloud
      </a>
    </div>

    {/* Compliance badges */}
    <div className="flex flex-wrap items-center justify-center gap-4 mb-4">
      {COMPLIANCE_BADGES.map((badge) => (
        <Link
          key={badge.label}
          to={`/security#${badge.anchor}`}
          className="flex items-center space-x-1 hover:text-slate-300 transition-colors group"
          title={badge.title || `Learn about our ${badge.label}`}
          aria-label={badge.ariaLabel || badge.label}
        >
          <svg 
            className={`w-3 h-3 transition-colors ${
              badge.variant === 'warning' 
                ? 'text-amber-500 group-hover:text-amber-400' 
                : 'text-green-500 group-hover:text-green-400'
            }`} 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414L8.414 15 3.293 9.879a1 1 0 011.414-1.414L8.414 12.172l6.879-6.879a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
          <span className="group-hover:underline">{badge.label}</span>
        </Link>
      ))}
    </div>

    {/* Legal links + copyright */}
    <div className="flex flex-wrap items-center justify-center gap-2 text-slate-500">
      <Link to="/privacy" className="hover:text-slate-300 transition-colors hover:underline">
        Privacy Policy
      </Link>
      <span>·</span>
      <Link to="/terms" className="hover:text-slate-300 transition-colors hover:underline">
        Terms of Service
      </Link>
      <span>·</span>
      <span>© 2026 RetainIQ</span>
    </div>
  </footer>
);

export default ComplianceFooter;
